import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Track from "@/pages/Track";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function ScrollToHash() {
  return null;
}

function App() {
  useEffect(() => {
    document.title = "Gridline Machined Plates — Custom Surron Plates, Wheelie Bars & E-Moto Parts";
  }, []);

  return (
    <div className="App bg-neutral-950 min-h-screen">
      <CartProvider>
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/track" element={<Track />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </CartProvider>
    </div>
  );
}

export default App;
